module.exports = __webpack_public_path__ + "static/media/IllustartionYellowBadge.3b3ccb4b.png";